export { default as OQAATView } from './OQAATView';
export * from './OQAATView';
export { default as ClassicView } from './ClassicView';
export * from './ClassicView';
